<template>
  <div :id="idElement" style="width: 100%"></div>
</template>
<script>

export default {
  name: "MapGoogleChart",
  props: [
    //? Id dado ao svg formado pelo google chart
    "idElement",
    //? Textos do tooltip (Dado) - Ex. "Apostas: 1000" (Apostas seria o Label)
    "labelTooltip", //* String
    //? Dados do mapa - Ex. "['Pernambuco', 120330]" (Pernambuco seria o State e
    //? 120330 seria o valor)
    "data", //* Array de arrays
    //? Cores que são usadas para visualizar a quantidade entre os valores - Ex.
    //? ["rgb(229,66,66)", "#acb2b9"] - cores mais a esquerda serão dadas ao
    //? menores valores e mais a direita serão dadas aos maiores valores
    "colors", //* Array de Strings (cor)
  ],
  watch: {
    labelTooltip() {
      this.buildChartMap();
    },
    data() {
      this.buildChartMap();
    },
    colors() {
      this.buildChartMap();
    },
  }, 
  methods: {
    buildChartMap() {
      window.google.charts.load('current', {
        'packages': ['geochart'],
        'mapsApiKey': 'AIzaSyA7-3NYWp0zC02Cd35WuqrbMd7GuJIWvzo'
      });

      const arrayToDataTable = [
        ['State', this.labelTooltip],
        ...this.data,
      ];

      const drawRegionsMap = () => {
        var data = window.google.visualization
          .arrayToDataTable(arrayToDataTable);

        var options = {
          region: "BR",
          displayMode: "region",
          resolution: "provinces",
          colorAxis: {
            colors: this.colors,
          },
          backgroundColor: {
            fill: "transparent",
            // stroke: "#cccccc",
            // strokeWidth: 0,
          },
          datalessRegionColor: "transparent",
        };
        
        var chart = new window.google.visualization
        .GeoChart(document.getElementById(this.idElement));
        
        chart.draw(data, options);
      }

      window.google.charts.setOnLoadCallback(drawRegionsMap);
    },
  },
}
</script>